import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import toast from 'react-hot-toast';

import { fetchUserByToken } from '../../../app/features/userSlice';
import {
    activeFreePlan,
    cancelSubscription,
    resumeSubscription
} from '../../../services/paymentService';
import { sendVerificationCancellationNotification } from '../../../services/verificationService';

import Billing from '../Billing/Billing';
import Pricing from '../Pricing/Pricing';
import Verification from '../Verification/Verification';
import Button from '../../../components/UI/Buttons/Button/Button';
import PaymentForm from '../../../components/Forms/Common/PaymentForm/PaymentForm';
import { useLocation, useNavigate } from 'react-router-dom';

function ProfileEmployerSubscription() {

    const [loading, setLoading] = useState(false);
    const [showVerification, setShowVerification] = useState(true);
    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.subscriptionStatus) { setShowVerification(false) }
    }, [user])

    const handleCancelSubscription = () => {
        setLoading(true);
        cancelSubscription({ token: userToken, endOfPeriod: user?.account_type === 'employer' ? true : true })
            .then((res) => {
                // If the user is a jobseeker, send a verification cancellation notification
                if (user?.account_type !== 'employer') {
                    try {
                        sendVerificationCancellationNotification(userToken)
                            .then(result => {
                                console.log('Cancellation notification sent:', result);
                            })
                            .catch(error => {
                                console.error('Error sending cancellation notification:', error);
                            });
                    } catch (error) {
                        console.error('Error sending cancellation notification:', error);
                    }
                }
                
                dispatch(fetchUserByToken(userToken));
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const handleResumeSubscription = () => {
        setLoading(true);
        resumeSubscription(userToken)
            .then((response) => {
                toast.success(t('subscription.resume_success', 'Subscription resumed successfully'));
                dispatch(fetchUserByToken(userToken));
                setLoading(false);
            })
            .catch(error => {
                console.error('Error resuming subscription:', error);
                toast.error(t('subscription.resume_error', 'Error resuming subscription'));
                setLoading(false);
            });
    }

    const handleActiveFreePlan = (endOfPeriod) => {
        setLoading(true);
        activeFreePlan({ token: userToken, endOfPeriod })
            .then(() => {
                setTimeout(() => {
                    dispatch(fetchUserByToken(userToken));
                    setLoading(false);
                }, 1000);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            });
    }

    const handleDowngradeNavigate = () => {
        navigate('/subscription-downgrade');
    }

    let subscriptionExpired = false;

    if (user?.subscriptionEndDate && new Date(user?.subscriptionEndDate) > new Date()) { subscriptionExpired = false; }
    else { subscriptionExpired = true; }

    let content = '';

    if (user?.subscriptionStatus === 'active') {
        content = (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                <Button 
                    onClick={handleDowngradeNavigate} 
                    type="button" 
                    color="blue" 
                    style={{ display: 'block', margin: 'auto', marginBottom: '15px' }}
                >
                    {t('general.UI.downgrade')}
                </Button>
                <Button 
                    onClick={handleCancelSubscription} 
                    type="submit" 
                    color="red" 
                    style={{ display: 'block', margin: 'auto' }}
                >
                    {loading ? t('general.UI.loading') : t('general.UI.cancel')}
                </Button>
            </div>
        );
    }
    else {
        if (subscriptionExpired) {
            content = <PaymentForm actionType={'pay_for_subscription'} />;
        }
    }
    const location = useLocation();
    const data = location.search;
    useEffect(() => {
        if (data.length > 0) {
            setShowVerification(true)
        }
    }, [data])
    useEffect(() => {
        if (user?.account_type == 'employer') {
            if (location.pathname === "/subscriptions") setShowVerification(true)
            else setShowVerification(false)
        }
    }, [user?.account_type, location])
    
    return (
        <>
            <Helmet>
                <title>FindCV - Subscription</title>
            </Helmet>
            {user?.account_type == 'jobseeker' ?
                <>
                    {showVerification ? (
                        <Verification />
                    ) : (
                        <Billing 
                            handleCancelSubscription={handleCancelSubscription} 
                            handleResumeSubscription={handleResumeSubscription}
                            onSeeAllPlans={() => {
                                setTimeout(() => {
                                    navigate('/subscriptions')
                                }, 0);
                                setShowVerification(true)
                            }} 
                        />
                    )}
                </>
                :
                <>
                    {showVerification ? (
                        <Pricing handleCancelSubscription={handleCancelSubscription}
                            handleActiveFreePlan={handleActiveFreePlan}
                            onSeeAllPlans={() => setShowVerification(false)} />
                    ) : (
                        <Billing
                            isEmployerSubscription={true}
                            handleCancelSubscription={handleCancelSubscription}
                            handleResumeSubscription={handleResumeSubscription}
                            onSeeAllPlans={() => {
                                setTimeout(() => {
                                    navigate('/subscriptions')
                                }, 0);
                                // setShowVerification(true)
                            }} />
                    )}


                </>
            }
        </>
    );
}

export default ProfileEmployerSubscription;


